// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bug-report-overlay {
  --br-ink: #1f1b2e;
  --br-muted: #55515f;
  --br-soft: #6f7588;
  --br-lavender: #d5d1fd;
  --br-mint: #bff1db;
  --br-peach: #f9e1be;
  --br-pink: #f2c4c4;
  --br-panel: #f4f2f8;
  --br-surface: #ffffff;
  --br-line: rgba(31, 27, 46, 0.1);
  --br-radius: 20px;

  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: safe center;
  justify-content: center;
  padding: 1.5rem;
  overflow-y: auto;
  overscroll-behavior: contain;
  background: rgba(18, 16, 26, 0.52);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  animation: bug-report-fade-in 0.18s ease-out;
}

@keyframes bug-report-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.bug-report-dialog {
  display: flex;
  flex-direction: column;
  width: min(100%, 720px);
  min-height: min(78vh, 640px);
  max-height: min(94vh, 860px);
  margin: auto;
  background: var(--br-surface);
  color: var(--br-ink);
  border: 1px solid var(--br-line);
  border-radius: var(--br-radius);
  box-shadow: 0 24px 60px rgba(18, 16, 26, 0.28);
  overflow: hidden;
  animation: bug-report-rise 0.22s ease-out;
}

@keyframes bug-report-rise {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.bug-report-dialog__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 1.4rem 1.75rem 1.15rem;
  border-bottom: 1px solid var(--br-line);
  background: linear-gradient(
    180deg,
    rgba(213, 209, 253, 0.35) 0%,
    var(--br-surface) 100%
  );
}

.bug-report-dialog__header-text {
  min-width: 0;
}

.bug-report-dialog__eyebrow {
  margin: 0 0 0.3rem;
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #5a5580;
}

.bug-report-dialog__title {
  margin: 0;
  font-family: "Merriweather", Georgia, serif;
  font-size: clamp(1.25rem, 2.4vw, 1.5rem);
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.25;
  color: var(--br-ink);
}

.bug-report-dialog__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 2.25rem;
  height: 2.25rem;
  margin: 0;
  padding: 0;
  border: 1px solid rgba(31, 27, 46, 0.12);
  border-radius: 999px;
  background: #f4f4f6;
  color: var(--br-ink);
  font-size: 1.35rem;
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s ease, transform 0.15s ease;
}

.bug-report-dialog__close:hover:not(:disabled) {
  background: #ebebef;
  transform: translateY(-1px);
}

.bug-report-dialog__close:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.bug-report-dialog__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 1.35rem 1.75rem 0.5rem;
  -webkit-overflow-scrolling: touch;
}

.bug-report-dialog__intro {
  margin: 0 0 1.05rem;
  padding: 0.85rem 0.95rem;
  border-radius: 12px;
  background: rgba(213, 209, 253, 0.28);
  border: 1px solid rgba(213, 209, 253, 0.75);
  border-left: 3px solid #8b84c7;
  color: var(--br-muted);
  font-size: 0.9rem;
  line-height: 1.45;
}

.bug-report-dialog__email {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  margin-bottom: 1.05rem;
  padding: 0.7rem 0.85rem;
  border-radius: 12px;
  background: var(--br-panel);
  border: 1px solid var(--br-line);
}

.bug-report-dialog__email-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 999px;
  background: var(--br-lavender);
  color: #403b55;
  font-size: 0.8rem;
  flex-shrink: 0;
}

.bug-report-dialog__email-meta {
  min-width: 0;
}

.bug-report-dialog__email-label {
  margin: 0;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--br-soft);
}

.bug-report-dialog__email-value {
  margin: 0.15rem 0 0;
  font-size: 0.92rem;
  font-weight: 650;
  color: var(--br-ink);
  word-break: break-all;
}

.bug-report-field {
  margin-bottom: 1.05rem;
}

.bug-report-field__label {
  display: block;
  margin: 0 0 0.5rem;
  font-size: 0.78rem;
  font-weight: 750;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--br-muted);
}

.bug-report-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
}

.bug-report-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 2.15rem;
  padding: 0.35rem 0.85rem;
  border: 1px solid rgba(31, 27, 46, 0.12);
  border-radius: 999px;
  background: var(--br-surface);
  color: #403b55;
  font-size: 0.84rem;
  font-weight: 650;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease,
    transform 0.15s ease, box-shadow 0.15s ease;
}

.bug-report-chip:hover:not(:disabled):not(.is-selected) {
  background: var(--br-panel);
  transform: translateY(-1px);
}

.bug-report-chip.is-selected {
  background: var(--br-lavender);
  border-color: rgba(120, 110, 180, 0.45);
  box-shadow: 0 0 0 1px rgba(120, 110, 180, 0.2);
  color: #302d45;
}

.bug-report-chip:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.bug-report-chip:focus-visible {
  outline: 2px solid #8b84c7;
  outline-offset: 2px;
}

.bug-report-textarea {
  width: 100%;
  min-height: 12rem;
  padding: 0.9rem 1rem;
  border: 1px solid var(--br-line);
  border-radius: 12px;
  background: var(--br-surface);
  color: var(--br-ink);
  font-size: 0.95rem;
  line-height: 1.45;
  resize: vertical;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.bug-report-textarea::placeholder {
  color: #9a96a8;
}

.bug-report-textarea:focus {
  outline: none;
  border-color: rgba(139, 132, 199, 0.65);
  box-shadow: 0 0 0 3px rgba(213, 209, 253, 0.55);
}

.bug-report-textarea:disabled {
  background: var(--br-panel);
  opacity: 0.75;
}

.bug-report-counter {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 0.45rem;
}

.bug-report-counter__count {
  margin: 0;
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--br-soft);
  font-variant-numeric: tabular-nums;
}

.bug-report-counter__count.is-near {
  color: #8a6a2a;
}

.bug-report-counter__count.is-full {
  color: #8a3d3d;
}

.bug-report-dialog__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.55rem;
  padding: 1.15rem 1.75rem 1.4rem;
  border-top: 1px solid var(--br-line);
  background: var(--br-surface);
  flex-shrink: 0;
}

.bug-report-dialog__cancel,
.bug-report-dialog__submit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 2.55rem;
  padding: 0.55rem 1.15rem;
  border-radius: 10px;
  font-weight: 750;
  font-size: 0.92rem;
  cursor: pointer;
  transition: background 0.15s ease, transform 0.15s ease, opacity 0.15s ease;
}

.bug-report-dialog__cancel {
  border: 1px solid rgba(31, 27, 46, 0.12);
  background: var(--br-panel);
  color: #403b55;
}

.bug-report-dialog__cancel:hover:not(:disabled) {
  background: #ebe8f2;
  transform: translateY(-1px);
}

.bug-report-dialog__submit {
  border: 1px solid rgba(120, 110, 180, 0.35);
  background: var(--br-lavender);
  color: #403b55;
  min-width: 8.5rem;
}

.bug-report-dialog__submit:hover:not(:disabled) {
  background: #c9c4f5;
  transform: translateY(-1px);
}

.bug-report-dialog__submit:disabled,
.bug-report-dialog__cancel:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  transform: none;
}

.bug-report-dialog__close:focus-visible,
.bug-report-dialog__cancel:focus-visible,
.bug-report-dialog__submit:focus-visible,
.bug-report-textarea:focus-visible {
  outline: 2px solid #8b84c7;
  outline-offset: 2px;
}

@media (max-width: 480px) {
  .bug-report-overlay {
    padding: 1rem;
  }

  .bug-report-dialog__header,
  .bug-report-dialog__body,
  .bug-report-dialog__footer {
    padding-left: 1.1rem;
    padding-right: 1.1rem;
  }

  .bug-report-dialog__footer {
    flex-direction: column-reverse;
  }

  .bug-report-dialog__cancel,
  .bug-report-dialog__submit {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/BugReportModal.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,gCAAgC;EAChC,iBAAiB;;EAEjB,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,wBAAwB;EACxB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,4BAA4B;EAC5B,YAAY;EACZ,6BAA6B;EAC7B,oBAAoB;EACpB,gCAAgC;EAChC,+BAA+B;EAC/B,8CAA8C;EAC9C,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,+BAA+B;EAC/B,uCAAuC;EACvC;;;;GAIC;AACH;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,2CAA2C;EAC3C,wCAAwC;EACxC,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,eAAe;EACf,SAAS;EACT,UAAU;EACV,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,8BAA8B;EAC9B,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,8BAA8B;EAC9B,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,wCAAwC;EACxC,oBAAoB;EACpB,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf;+CAC6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,uCAAuC;EACvC,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,gCAAgC;EAChC,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,+BAA+B;EAC/B,oCAAoC;EACpC,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,2EAA2E;AAC7E;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;EAC3C,8BAA8B;EAC9B,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;;;EAIE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;;IAGE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":[".bug-report-overlay {\n  --br-ink: #1f1b2e;\n  --br-muted: #55515f;\n  --br-soft: #6f7588;\n  --br-lavender: #d5d1fd;\n  --br-mint: #bff1db;\n  --br-peach: #f9e1be;\n  --br-pink: #f2c4c4;\n  --br-panel: #f4f2f8;\n  --br-surface: #ffffff;\n  --br-line: rgba(31, 27, 46, 0.1);\n  --br-radius: 20px;\n\n  position: fixed;\n  inset: 0;\n  z-index: 1200;\n  display: flex;\n  align-items: safe center;\n  justify-content: center;\n  padding: 1.5rem;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  background: rgba(18, 16, 26, 0.52);\n  backdrop-filter: blur(6px);\n  -webkit-backdrop-filter: blur(6px);\n  animation: bug-report-fade-in 0.18s ease-out;\n}\n\n@keyframes bug-report-fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.bug-report-dialog {\n  display: flex;\n  flex-direction: column;\n  width: min(100%, 720px);\n  min-height: min(78vh, 640px);\n  max-height: min(94vh, 860px);\n  margin: auto;\n  background: var(--br-surface);\n  color: var(--br-ink);\n  border: 1px solid var(--br-line);\n  border-radius: var(--br-radius);\n  box-shadow: 0 24px 60px rgba(18, 16, 26, 0.28);\n  overflow: hidden;\n  animation: bug-report-rise 0.22s ease-out;\n}\n\n@keyframes bug-report-rise {\n  from {\n    opacity: 0;\n    transform: translateY(10px) scale(0.985);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.bug-report-dialog__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 1.4rem 1.75rem 1.15rem;\n  border-bottom: 1px solid var(--br-line);\n  background: linear-gradient(\n    180deg,\n    rgba(213, 209, 253, 0.35) 0%,\n    var(--br-surface) 100%\n  );\n}\n\n.bug-report-dialog__header-text {\n  min-width: 0;\n}\n\n.bug-report-dialog__eyebrow {\n  margin: 0 0 0.3rem;\n  font-size: 0.7rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #5a5580;\n}\n\n.bug-report-dialog__title {\n  margin: 0;\n  font-family: \"Merriweather\", Georgia, serif;\n  font-size: clamp(1.25rem, 2.4vw, 1.5rem);\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.25;\n  color: var(--br-ink);\n}\n\n.bug-report-dialog__close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 2.25rem;\n  height: 2.25rem;\n  margin: 0;\n  padding: 0;\n  border: 1px solid rgba(31, 27, 46, 0.12);\n  border-radius: 999px;\n  background: #f4f4f6;\n  color: var(--br-ink);\n  font-size: 1.35rem;\n  line-height: 1;\n  cursor: pointer;\n  transition: background 0.15s ease, transform 0.15s ease;\n}\n\n.bug-report-dialog__close:hover:not(:disabled) {\n  background: #ebebef;\n  transform: translateY(-1px);\n}\n\n.bug-report-dialog__close:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.bug-report-dialog__body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  padding: 1.35rem 1.75rem 0.5rem;\n  -webkit-overflow-scrolling: touch;\n}\n\n.bug-report-dialog__intro {\n  margin: 0 0 1.05rem;\n  padding: 0.85rem 0.95rem;\n  border-radius: 12px;\n  background: rgba(213, 209, 253, 0.28);\n  border: 1px solid rgba(213, 209, 253, 0.75);\n  border-left: 3px solid #8b84c7;\n  color: var(--br-muted);\n  font-size: 0.9rem;\n  line-height: 1.45;\n}\n\n.bug-report-dialog__email {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  margin-bottom: 1.05rem;\n  padding: 0.7rem 0.85rem;\n  border-radius: 12px;\n  background: var(--br-panel);\n  border: 1px solid var(--br-line);\n}\n\n.bug-report-dialog__email-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  border-radius: 999px;\n  background: var(--br-lavender);\n  color: #403b55;\n  font-size: 0.8rem;\n  flex-shrink: 0;\n}\n\n.bug-report-dialog__email-meta {\n  min-width: 0;\n}\n\n.bug-report-dialog__email-label {\n  margin: 0;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--br-soft);\n}\n\n.bug-report-dialog__email-value {\n  margin: 0.15rem 0 0;\n  font-size: 0.92rem;\n  font-weight: 650;\n  color: var(--br-ink);\n  word-break: break-all;\n}\n\n.bug-report-field {\n  margin-bottom: 1.05rem;\n}\n\n.bug-report-field__label {\n  display: block;\n  margin: 0 0 0.5rem;\n  font-size: 0.78rem;\n  font-weight: 750;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--br-muted);\n}\n\n.bug-report-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.45rem;\n}\n\n.bug-report-chip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 2.15rem;\n  padding: 0.35rem 0.85rem;\n  border: 1px solid rgba(31, 27, 46, 0.12);\n  border-radius: 999px;\n  background: var(--br-surface);\n  color: #403b55;\n  font-size: 0.84rem;\n  font-weight: 650;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease,\n    transform 0.15s ease, box-shadow 0.15s ease;\n}\n\n.bug-report-chip:hover:not(:disabled):not(.is-selected) {\n  background: var(--br-panel);\n  transform: translateY(-1px);\n}\n\n.bug-report-chip.is-selected {\n  background: var(--br-lavender);\n  border-color: rgba(120, 110, 180, 0.45);\n  box-shadow: 0 0 0 1px rgba(120, 110, 180, 0.2);\n  color: #302d45;\n}\n\n.bug-report-chip:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.bug-report-chip:focus-visible {\n  outline: 2px solid #8b84c7;\n  outline-offset: 2px;\n}\n\n.bug-report-textarea {\n  width: 100%;\n  min-height: 12rem;\n  padding: 0.9rem 1rem;\n  border: 1px solid var(--br-line);\n  border-radius: 12px;\n  background: var(--br-surface);\n  color: var(--br-ink);\n  font-size: 0.95rem;\n  line-height: 1.45;\n  resize: vertical;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.bug-report-textarea::placeholder {\n  color: #9a96a8;\n}\n\n.bug-report-textarea:focus {\n  outline: none;\n  border-color: rgba(139, 132, 199, 0.65);\n  box-shadow: 0 0 0 3px rgba(213, 209, 253, 0.55);\n}\n\n.bug-report-textarea:disabled {\n  background: var(--br-panel);\n  opacity: 0.75;\n}\n\n.bug-report-counter {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-top: 0.45rem;\n}\n\n.bug-report-counter__count {\n  margin: 0;\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: var(--br-soft);\n  font-variant-numeric: tabular-nums;\n}\n\n.bug-report-counter__count.is-near {\n  color: #8a6a2a;\n}\n\n.bug-report-counter__count.is-full {\n  color: #8a3d3d;\n}\n\n.bug-report-dialog__footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.55rem;\n  padding: 1.15rem 1.75rem 1.4rem;\n  border-top: 1px solid var(--br-line);\n  background: var(--br-surface);\n  flex-shrink: 0;\n}\n\n.bug-report-dialog__cancel,\n.bug-report-dialog__submit {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 2.55rem;\n  padding: 0.55rem 1.15rem;\n  border-radius: 10px;\n  font-weight: 750;\n  font-size: 0.92rem;\n  cursor: pointer;\n  transition: background 0.15s ease, transform 0.15s ease, opacity 0.15s ease;\n}\n\n.bug-report-dialog__cancel {\n  border: 1px solid rgba(31, 27, 46, 0.12);\n  background: var(--br-panel);\n  color: #403b55;\n}\n\n.bug-report-dialog__cancel:hover:not(:disabled) {\n  background: #ebe8f2;\n  transform: translateY(-1px);\n}\n\n.bug-report-dialog__submit {\n  border: 1px solid rgba(120, 110, 180, 0.35);\n  background: var(--br-lavender);\n  color: #403b55;\n  min-width: 8.5rem;\n}\n\n.bug-report-dialog__submit:hover:not(:disabled) {\n  background: #c9c4f5;\n  transform: translateY(-1px);\n}\n\n.bug-report-dialog__submit:disabled,\n.bug-report-dialog__cancel:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.bug-report-dialog__close:focus-visible,\n.bug-report-dialog__cancel:focus-visible,\n.bug-report-dialog__submit:focus-visible,\n.bug-report-textarea:focus-visible {\n  outline: 2px solid #8b84c7;\n  outline-offset: 2px;\n}\n\n@media (max-width: 480px) {\n  .bug-report-overlay {\n    padding: 1rem;\n  }\n\n  .bug-report-dialog__header,\n  .bug-report-dialog__body,\n  .bug-report-dialog__footer {\n    padding-left: 1.1rem;\n    padding-right: 1.1rem;\n  }\n\n  .bug-report-dialog__footer {\n    flex-direction: column-reverse;\n  }\n\n  .bug-report-dialog__cancel,\n  .bug-report-dialog__submit {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
